// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.adminSondagePage {
  padding: 14px 0 28px;
}

/* --- Réutilise les mêmes classes que AdminGroupeCategoriesPage.css --- */
/* adminGroupHeader, adminGroupTitle, adminGroupSubtitle, adminGroupActions,
   adminBtn, adminBtnSoft, adminBtnPrimary, adminGroupFilters, filterItem,
   adminGroupTableWrap, adminGroupTable, rowTitle, rowMuted, rowActions,
   btnAction, btnDanger, pill, pillGood, pillDanger, pillNeutral,
   pillPremium, pillStandard, adminEmpty, adminPagination, pageInfo,
   adminModalOverlay, adminModal, adminModalHeader, adminModalTitle,
   adminModalClose, adminModalBody, adminModalFooter
   -> importe/colle ces règles depuis AdminGroupeCategoriesPage.css si elles
   ne sont pas déjà globales à /admin. */

/* --- Onglets de section (Vendeur / Article) --- */
.adminSondageTabs {
  display: flex;
  gap: 8px;
  margin: 4px 0 14px;
}

.adminSondageTab {
  border: 0;
  border-radius: 12px;
  padding: 9px 14px;
  background: #f3f4f6;
  color: #111827;
  font-weight: 800;
  display: flex;
  align-items: center;
  gap: 8px;
}

.adminSondageTabActive {
  background: var(--couleur-principale);
  color: #fff;
}

.adminSondageTabCount {
  background: rgba(255, 255, 255, .35);
  border-radius: 999px;
  padding: 1px 8px;
  font-size: 12px;
}

.adminSondageTab:not(.adminSondageTabActive) .adminSondageTabCount {
  background: #e5e7eb;
  color: #111827;
}

/* --- Filtres (recherche + type + tri) --- */
.adminSondageFilters {
  grid-template-columns: 2fr 1fr 1fr;
}

/* --- Choix proposés (modale) --- */
.adminSondageChoixList {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.adminSondageChoixPill {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.adminSondageChoixRemove {
  border: 0;
  background: transparent;
  display: inline-flex;
  align-items: center;
  line-height: 1;
  color: inherit;
  opacity: .6;
}

.adminSondageChoixRemove:hover {
  opacity: 1;
}

@media (max-width: 992px) {
  .adminSondageFilters {
    grid-template-columns: 1fr;
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/css/sondage/AdminSondageQuestion.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;AACtB;;AAEA,0EAA0E;AAC1E;;;;;;;;wCAQwC;;AAExC,mDAAmD;AACnD;EACE,aAAa;EACb,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,qCAAqC;EACrC,WAAW;AACb;;AAEA;EACE,oCAAoC;EACpC,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,6CAA6C;AAC7C;EACE,kCAAkC;AACpC;;AAEA,oCAAoC;AACpC;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,uBAAuB;EACvB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,cAAc;EACd,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF","sourcesContent":[".adminSondagePage {\n  padding: 14px 0 28px;\n}\n\n/* --- Réutilise les mêmes classes que AdminGroupeCategoriesPage.css --- */\n/* adminGroupHeader, adminGroupTitle, adminGroupSubtitle, adminGroupActions,\n   adminBtn, adminBtnSoft, adminBtnPrimary, adminGroupFilters, filterItem,\n   adminGroupTableWrap, adminGroupTable, rowTitle, rowMuted, rowActions,\n   btnAction, btnDanger, pill, pillGood, pillDanger, pillNeutral,\n   pillPremium, pillStandard, adminEmpty, adminPagination, pageInfo,\n   adminModalOverlay, adminModal, adminModalHeader, adminModalTitle,\n   adminModalClose, adminModalBody, adminModalFooter\n   -> importe/colle ces règles depuis AdminGroupeCategoriesPage.css si elles\n   ne sont pas déjà globales à /admin. */\n\n/* --- Onglets de section (Vendeur / Article) --- */\n.adminSondageTabs {\n  display: flex;\n  gap: 8px;\n  margin: 4px 0 14px;\n}\n\n.adminSondageTab {\n  border: 0;\n  border-radius: 12px;\n  padding: 9px 14px;\n  background: #f3f4f6;\n  color: #111827;\n  font-weight: 800;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.adminSondageTabActive {\n  background: var(--couleur-principale);\n  color: #fff;\n}\n\n.adminSondageTabCount {\n  background: rgba(255, 255, 255, .35);\n  border-radius: 999px;\n  padding: 1px 8px;\n  font-size: 12px;\n}\n\n.adminSondageTab:not(.adminSondageTabActive) .adminSondageTabCount {\n  background: #e5e7eb;\n  color: #111827;\n}\n\n/* --- Filtres (recherche + type + tri) --- */\n.adminSondageFilters {\n  grid-template-columns: 2fr 1fr 1fr;\n}\n\n/* --- Choix proposés (modale) --- */\n.adminSondageChoixList {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.adminSondageChoixPill {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.adminSondageChoixRemove {\n  border: 0;\n  background: transparent;\n  display: inline-flex;\n  align-items: center;\n  line-height: 1;\n  color: inherit;\n  opacity: .6;\n}\n\n.adminSondageChoixRemove:hover {\n  opacity: 1;\n}\n\n@media (max-width: 992px) {\n  .adminSondageFilters {\n    grid-template-columns: 1fr;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
